import { render, staticRenderFns } from "./yesTableColumn.vue?vue&type=template&id=3ebf0a7a"
import script from "./yesTableColumn.vue?vue&type=script&lang=js"
export * from "./yesTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports